module.exports = __webpack_public_path__ + "img/phone-popup.989983ca.svg";